module.exports = __webpack_public_path__ + "static/mapa-e0684bf09f9caea0a234384f902359ca.png";